import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../../helpers/helper';
import { AlertasModales } from '../../../helpers/alertasModales';
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CuadreService } from '../../../services/cuadre.service';

import { CurrencyPipe } from '@angular/common';

  @Component({
    selector: 'app-nuevo',
    templateUrl: './nuevo.component.html',
    styleUrls: ['./nuevo.component.css']
  })
  export class NuevoGastoComponent implements OnInit {


  fechaGasto: NgbDateStruct;
  now = new Date(this.helper.getDate());
  rutas = [];
  empleados = [];
  form: FormGroup;
  loading = false;
  error = '';
  constructor(private helper: Helper,
              private rutaService: RutasService,
              private modals: AlertasModales,
              private cuadreService: CuadreService,
              private empleadoService: EmpleadosServicio) {
  this.fechaGasto = {
    year: this.now.getFullYear(),
    month: this.now.getMonth() + 1,
    day: this.now.getDate()};
    this.initForm();
    this.initRutas();
  }

  ngOnInit() {
    this.initEmpleados();
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas().subscribe(res => this.rutas = res.rutas);
  }

  private initEmpleados(): void {
    this.form.get('ID_RUTA').valueChanges.subscribe(res => {
      if (res) {
        console.log(res);
        this.empleadoService.empleadosPorRutasAsignadas(res)
        .subscribe(result => {
          this.empleados = result;
          this.form.get('ID_EMPLEADO').enable();
        });
      } else {
        this.form.get('ID_EMPLEADO').setValue('');
        this.form.get('ID_EMPLEADO').disable();
        this.empleados = [];
      }
    });

  }

  private initForm(): void {
    this.form = new FormGroup({
      fecha_registro: new FormControl({
        year: this.now.getFullYear(),
        month: this.now.getMonth() + 1,
        day: this.now.getDate(),
        time: this.now.getTime()
        },
        Validators.required),
      ID_RUTA: new FormControl('', Validators.required),
      ID_EMPLEADO: new FormControl('', Validators.required),
      tipo_gasto: new FormControl('' , Validators.required),
      descripcion: new FormControl(''),
      capital: new FormControl('', Validators.required)
    });

    if (!this.form.get('ID_RUTA').value) {
      this.form.get('ID_EMPLEADO').disable();
    }
  }

  registrarGastos() {

    if (this.form.valid) {

      const fecha = this.form.get('fecha_registro').value;

      const currencyPipe = new CurrencyPipe('en-US');

      const html = `¿Desea registrar el gasto con un monto de ${  currencyPipe.transform(this.form.get('capital').value,
        'RD$ ', 'symbol', '1.0-2') }?`;

      this.modals.confirmNgbModal(html, 'Registro de Gasto').then(resp => {
        if (resp && resp === 'si') {
          this.cuadreService.registrarGastos(this.form.value).subscribe((res: any) => {


            if (res && res.ok !== false) {
              this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-sun-o');

              for (const key of Object.keys(this.form.controls)) {
                if (key === 'fecha_registro') {
                  this.form.get(key).setValue(this.fechaGasto);
                } else {
                  this.form.get(key).setValue('');
                }
              }
              this.updateTipoGasto();
              this.form.markAsUntouched();
            }
          }, err => {
            if (err) {


              this.modals.agreeModal(
                'ERROR DE VALIDACIÓN',
                err.error.message,
                'CERRAR',
                'red',
                'modern',
                'btn-red',
                'fa fa-exclamation-triangle');
            }
          });
        }
      });
    }
  }

  updateTipoGasto() {
    const ruta = this.form.get('ID_RUTA');
    if ( ruta.value === '-1') {
      this.form.get('ID_EMPLEADO').clearValidators();
      this.form.get('ID_EMPLEADO').setValue('');
      this.form.get('ID_EMPLEADO').updateValueAndValidity();
    } else {
      this.form.get('ID_EMPLEADO').setValidators(Validators.required);
      this.form.get('ID_EMPLEADO').setValue('');
      this.form.get('ID_EMPLEADO').updateValueAndValidity();
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/gastos/nuevo/nuevo.component.ts